module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['collection-diptych', {
      'collection-diptych--white': _vm.variant === 'white'
    }]
  }, _vm._l((_vm.images), function(image, index) {
    return (index < 2) ? _c('div', {
      staticClass: "panel"
    }, [_c('collection-image', {
      attrs: {
        "image": _vm.buildImgObj(image),
        "grayscale": true
      }
    })], 1) : _vm._e()
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f5ec896c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Collection__Story__Diptych.vue
// module id = 399
// module chunks = 1